module.exports = __webpack_public_path__ + "static/media/Biker_mobix.a4d23b6f.jpg";